<template>
  <div class="split-section d-flex align-items-center flex-wrap forgot-password">
    <info></info>
    <div
      class="right-infosec d-flex align-items-center text-center flex-wrap justify-content-center"
    >
      <h1 v-if="showSuccessAlertMessage">{{apiSuccessMessage}}</h1>
      <div v-if="!showSuccessAlertMessage" class="signup-form">
        <h2>Forgot Password</h2>
        <div class="gr-form">
          <form @submit="forgotPassword" name="forgotPasswordForm">
            <div class="alert alert-danger alert-dismissible" role="alert" v-if="showAlertMessage">
              {{apiErrorMessage}}
              <img
                class="close"
                src="assets/images/close.svg"
                data-dismiss="alert"
                aria-label="close"
                @click="showAlertMessage = false"
              />
            </div>

            <div class="form-group">
              <label for="email" class="email">Email</label>
              <input
                type="email"
                class="form-control"
                id="email"
                v-model="email"
                name="email"
                v-validate="'required|email'"
                data-vv-as="Email"
              />
              <span class="invalid-feedback">{{ errors.first('email') }}</span>
            </div>
            <div>
              <button type="submit" class="btn btn-primary">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Info from "./Info";
import { FORGOT_PASSWORD } from "../../store/auth/action.type";
export default {
  components: { info: Info },
  data() {
    return {
      email: "",
      apiSuccessMessage: "",
      apiErrorMessage: "",
      showSuccessAlertMessage: false,
      showAlertMessage: false,
      success: false
    };
  },
  methods: {
    forgotPassword(e) {
      e.preventDefault();
      const body = {
        email: this.email
      };
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store
            .dispatch(FORGOT_PASSWORD, body)
            .then(response => {
              if (response.status != 200) {
                this.apiErrorMessage = response.data.message;
                this.showAlertMessage = true;
              } else {
                this.apiSuccessMessage = response.data.message;
                this.showSuccessAlertMessage = true;
              }
            })
            .catch(error => {
              this.apiErrorMessage = error.response.data.message;
              this.showAlertMessage = true;
            });
        }
      });
    }
  }
};
</script>
<style scoped>
h1 {
  font-size: 20px;
  color: #a697c7;
}
</style>